<div class="filter-container dense-component-container">
	<mat-form-field subscriptSizing="dynamic">
		<mat-icon matPrefix>search</mat-icon>
		<input matInput>
	</mat-form-field>
	<button mat-mini-fab><mat-icon>filter_alt</mat-icon></button>
</div>
